/**
 * @generated SignedSource<<e4c03bea798abbc88a8530b8e4b38216>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type saveApplyRefundDelegationFilesMutation$variables = {
  autographImage: string;
  delegationDocumentFile: string;
  refundId: string;
  signedAt: string;
};
export type saveApplyRefundDelegationFilesMutation$data = {
  readonly saveApplyRefundDelegationFiles: {
    readonly autographImageKey: string | null | undefined;
    readonly delegationFileKey: string | null | undefined;
    readonly errors: {
      readonly code: ErrorType;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type saveApplyRefundDelegationFilesMutation = {
  response: saveApplyRefundDelegationFilesMutation$data;
  variables: saveApplyRefundDelegationFilesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autographImage"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "delegationDocumentFile"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signedAt"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "autographImage",
        "variableName": "autographImage"
      },
      {
        "kind": "Variable",
        "name": "delegationDocumentFile",
        "variableName": "delegationDocumentFile"
      },
      {
        "kind": "Variable",
        "name": "refundId",
        "variableName": "refundId"
      },
      {
        "kind": "Variable",
        "name": "signedAt",
        "variableName": "signedAt"
      }
    ],
    "concreteType": "SaveApplyDelegationOutput",
    "kind": "LinkedField",
    "name": "saveApplyRefundDelegationFiles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "autographImageKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "delegationFileKey",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "saveApplyRefundDelegationFilesMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "saveApplyRefundDelegationFilesMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "6f43dee66125037889d25e173ab6b6c2",
    "id": null,
    "metadata": {},
    "name": "saveApplyRefundDelegationFilesMutation",
    "operationKind": "mutation",
    "text": "mutation saveApplyRefundDelegationFilesMutation(\n  $signedAt: String!\n  $autographImage: String!\n  $delegationDocumentFile: String!\n  $refundId: String!\n) {\n  saveApplyRefundDelegationFiles(signedAt: $signedAt, autographImage: $autographImage, delegationDocumentFile: $delegationDocumentFile, refundId: $refundId) {\n    result\n    errors {\n      code\n    }\n    autographImageKey\n    delegationFileKey\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe216c79519a582d34cac0fb1035bae1";

export default node;
